import { useState, useCallback } from 'react';

export type FeatureName = 'debugger' | 'modelEditor' | 'roles' | 'i18n';

export function useFeatureFlags(initialConfig: {
  features: Record<FeatureName, { enabled: boolean }>;
}) {
  const [config, setConfig] = useState(initialConfig);

  const setFeature = (name: FeatureName, enabled: boolean) => {
    setConfig((state) => ({
      ...state,
      features: {
        ...state.features,
        [name]: {
          enabled,
        },
      },
    }));
  };

  const isFeatureEnabled = useCallback(
    (...features: FeatureName[]) =>
      features.every((name) => config.features[name]?.enabled),
    [config.features],
  );

  return {
    setFeature,
    isFeatureEnabled,
  };
}
